// @ts-ignore
export class AttachmentTypeModel {
  id: string;
  icon: string;
  title: string;
  titleMpv: string;
  extensions?: string[];
  disabled?: string;
  labels?: string[];

  /**
   * Labely:
   *
   * case - pro maja smlouvy
   * subject
   * gp
   * opinion
   * component - pro epd soubory
   * sample
   * doss
   * acquisitionDeed - nabyvaci listina
   */

  static readonly types: AttachmentTypeModel[] = [
    {
      id: 'CONTRACT',
      icon: 'fa-file',
      title: 'Návrh smlouvy',
      titleMpv: 'Smlouva - Návrh (ze vzoru)',
      labels: ['case'],
    },
    {
      id: 'CONTRACT_EXTERNAL',
      icon: 'fa-hand-o-right',
      title: 'Smlouva - Návrh (externí vzor)',
      titleMpv: 'Smlouva - Návrh (externí vzor)',
      labels: ['component'],
    },
    {
      id: 'COVERING_LETTER',
      icon: 'fa-file-text',
      title: 'Průvodní dopis',
      titleMpv: 'Průvodní dopis (F01)',
      labels: ['case'],
    },
    {
      id: 'COVERING_LETTER_EXTERNAL',
      icon: 'fa-file-text',
      title: 'Průvodní dopis (externí vzor)',
      titleMpv: 'Průvodní dopis (externí vzor)',
      labels: ['component'],
    },
    {
      id: 'INFORMATION_LETTER',
      icon: 'fa-file-text',
      title: 'Informační dopis',
      titleMpv: 'Informační dopis',
      labels: ['case'],
    },
    {
      id: 'FINANCIAL_CONTROL',
      icon: 'fa-fonticons',
      title: 'Finanční kontrola FINKO',
      titleMpv: 'Dokument finanční kontroly před vznikem závazku (F13)',
      labels: ['case'],
    },
    {
      id: 'PAYMENT_ORDER',
      icon: 'fa-money',
      title: 'Platební příkaz',
      titleMpv: 'Dokument finanční kontroly - příkaz k proplacení (F25)',
      labels: ['case'],
    },
    {
      id: 'PRELIMINARY_PAYMENT_ORDER',
      icon: 'fa-list-ol',
      title: 'Proforma platebního příkazu',
      titleMpv: 'Proforma platebního příkazu',
      labels: ['case'],
    },
    {
      id: 'OTHER',
      icon: 'fa-file-o',
      title: 'Nezařazené - ostatní',
      titleMpv: 'Ostatní dokumenty (F14)',
      labels: ['case', 'subject', 'gp', 'opinion'],
    },
    {
      id: 'CONTRACT_APPROVED_BY_INVESTOR',
      icon: 'fa-hand-o-right',
      title: 'Návrh smlouvy schválený investorem',
      titleMpv: 'Návrh smlouvy schválený investorem',
      labels: ['case'],
    },
    {
      id: 'CONTRACT_MAP_ATTACHMENT',
      icon: 'fa-map',
      title: 'Mapová příloha smlouvy',
      titleMpv: 'Mapová příloha smlouvy (z MPV)',
      labels: ['case'],
    },
    {
      id: 'SIGNED_CONTRACT_SCAN',
      icon: 'fa-handshake-o',
      title: 'Sken všestranně podepsané smlouvy',
      titleMpv: 'nabývací listina: kopie - Smlouva podepsaná všemi stranami',
      labels: ['case', 'component', 'acquisitionDeed'],
      extensions: ['pdf'],
    },
    {
      id: 'SIGNED_CONTRACT_SCAN_ORG',
      icon: 'fa-handshake-o',
      title: 'Sken všestranně podepsané smlouvy - originál',
      titleMpv: 'nabývací listina: originál - Smlouva podepsaná všemi stranami',
      labels: ['component', 'acquisitionDeed'],
      extensions: ['pdf'],
    },
    {
      id: 'CONTRACT_ADDENDUM',
      icon: 'fa-handshake-o',
      title: 'Dodatek smlouvy',
      titleMpv: 'nabývací listina: kopie - Smlouva dodatek',
      labels: ['case', 'component', 'acquisitionDeed'],
      extensions: ['pdf'],
    },
    {
      id: 'CONTRACT_ADDENDUM_ORG',
      icon: 'fa-handshake-o',
      title: 'Dodatek smlouvy - originál',
      titleMpv: 'nabývací listina: originál - Smlouva dodatek',
      labels: ['component', 'acquisitionDeed'],
      extensions: ['pdf'],
    },
    {
      id: 'BUILDING_PLACEMENT_LIABILITY',
      icon: 'fa-file-o',
      title: 'Souhlas s umístěním stavby',
      titleMpv: 'nabývací listina: Souhlas s umístěním stavby)',
      labels: ['component', 'acquisitionDeed'],
    },
    {
      id: 'ACCESS_TO_LAND_LIABILITY',
      icon: 'fa-file-o',
      title: 'Souhlas se vstupem na pozemek',
      titleMpv: 'nabývací listina: Souhlas se vstupem na pozemek',
      labels: ['component', 'acquisitionDeed'],
    },
    {
      id: 'OWNER_STATEMENT_LIABILITY',
      icon: 'fa-file-o',
      title: 'Vyjádření vlastníka',
      titleMpv: 'nabývací listina: Vyjádření vlastníka',
      labels: ['component', 'acquisitionDeed'],
    },
    {
      id: 'EXPROPRIATION_DECISION',
      icon: 'fa-handshake-o',
      title: 'Rozhodnutí o vyvlastnění',
      titleMpv: 'nabývací listina: Rozhodnutí o vyvlastnění',
      labels: ['case', 'acquisitionDeed'],
      extensions: ['pdf'],
    },
    {
      id: 'EXPROPRIATION_ENFORCEABLE',
      icon: 'fa-file-o',
      title: 'Rozhodnutí o vyvlastnění - Nabytí právní moci',
      titleMpv: 'nabývací listina: Rozhodnutí o vyvlastnění - Nabytí právní moci',
      labels: ['component', 'acquisitionDeed'],
    },
    {
      id: 'AUCTION_DECISION',
      icon: 'fa-file-o',
      title: 'Rozhodnutí o dražbě',
      titleMpv: 'nabývací listina: Rozhodnutí o dražbě',
      labels: ['component', 'acquisitionDeed'],
    },
    {
      id: 'EXECUTION_DECISION',
      icon: 'fa-file-o',
      title: 'Rozhodnutí o exekuci',
      titleMpv: 'nabývací listina: Rozhodnutí o exekuci',
      labels: ['component', 'acquisitionDeed'],
    },
    {
      id: 'OTHER_DOCUMENT',
      icon: 'fa-file-o',
      title: 'Ostatní dokumenty',
      titleMpv: 'ostatní: neupřesněno',
      labels: ['component'],
    },
    {
      id: 'OTHER_MAILROOM',
      icon: 'fa-file-o',
      title: 'Podatelna',
      titleMpv: 'ostatní: podatelna',
      labels: ['component'],
    },
    {
      id: 'PARCEL_SPLIT_PRE_APPROVE_BY_BUILDING_AUTHORITY_SCAN',
      icon: 'fa-hand-o-right',
      title: 'Sken předběžného schválení dělení pozemků od SÚ',
      titleMpv: 'ostatní: Předběžné schválení dělení pozemků od SÚ',
      labels: ['gp', 'component'],
    },
    {
      id: 'PARCEL_SPLIT_PRE_APPROVE_BY_OWNER_SCAN',
      icon: 'fa-handshake-o',
      title: 'Sken předběžného schválení dělení pozemků od vlastníka',
      titleMpv: 'ostatní: Předběžné schválení dělení pozemků vlastníkem',
      labels: ['gp', 'component'],
    },
    {
      id: 'ENTRY_PROPOSAL',
      icon: 'fa-file-o',
      title: 'Návrh na vklad',
      titleMpv: 'ostatní: Návrh na vklad',
      labels: ['component'],
    },
    {
      id: 'ENTRY_PROPOSAL_SIGNED_BY_INVESTOR',
      icon: 'fa-file-o',
      title: 'Návrh na vklad podepsaný investorem',
      titleMpv: 'ostatní: Návrh na vklad podepsaný ŘSD',
      labels: ['component'],
    },
    {
      id: 'COUNTERPARTY_CONTRACT_PROPOSAL',
      icon: 'fa-file-o',
      title: 'Návrh smlouvy protistrany',
      titleMpv: 'ostatní: Návrh smlouvy protistrany',
      labels: ['component'],
    },
    {
      id: 'FINANCIAL_CONTROL_BEFORE',
      icon: 'fa-file-o',
      title: 'FINKO - před vznikem závazku',
      titleMpv: 'ostatní: FINKO - před vznikem závazku',
      labels: ['component'],
    },
    {
      id: 'FINANCIAL_CONTROL_ORDER',
      icon: 'fa-file-o',
      title: 'FINKO - příkaz k proplacení',
      titleMpv: 'ostatní: FINKO - příkaz k proplacení',
      labels: ['component'],
    },
    {
      id: 'POWER_OF_ATTORNEY',
      icon: 'fa-file-o',
      title: 'Plná moc',
      titleMpv: 'ostatní: Plná moc',
      labels: ['component'],
    },
    {
      id: 'POWER_OF_ATTORNEY_TO_DIVIDE',
      icon: 'fa-file-text',
      title: 'Plná moc k dělení pozemku',
      titleMpv: 'ostatní: Plná moc k dělení pozemku',
      labels: ['case', 'subject'],
    },
    {
      id: 'RELOCATION_CONTRACT',
      icon: 'fa-file-o',
      title: 'Přeložková smlouva',
      titleMpv: 'ostatní: Přeložková smlouva',
      labels: ['component'],
    },
    {
      id: 'DECISION',
      icon: 'fa-file-o',
      title: 'Rozhodnutí',
      titleMpv: 'ostatní: Rozhodnutí',
      labels: ['component'],
    },
    {
      id: 'INTER_DECISION',
      icon: 'fa-file-o',
      title: 'Mezitímní rozhodnutí',
      titleMpv: 'ostatní: Rozhodnutí - Mezitímní rozhodnutí',
      labels: ['component'],
    },
    {
      id: 'INTER_DECISION_REQUEST',
      icon: 'fa-file-o',
      title: 'Žádost o mezitímní rozhodnutí',
      titleMpv: 'ostatní: Rozhodnutí - Žádost o mezitímní rozhodnutí',
      labels: ['component'],
    },
    {
      id: 'AUCTION_RESULT_DECISION',
      icon: 'fa-file-o',
      title: 'Rozhodnutí o udělení příklepu v dražbě nemovitostí',
      titleMpv: 'ostatní: Rozhodnutí o udělení příklepu v dražbě nemovitostí)',
      labels: ['component'],
    },
    {
      id: 'SIGNED_CONTRACT_BY_INVESTOR',
      icon: 'fa-file-o',
      title: 'Smlouva - Podepsaná investorem',
      titleMpv: 'ostatní: Smlouva - Podepsaná ŘSD',
      labels: ['component'],
    },
    {
      id: 'SIGNED_CONTRACT',
      icon: 'fa-file-o',
      title: 'Smlouva - Podepsaná vlastníkem / jinou stranou',
      titleMpv: 'ostatní: Smlouva - Podepsaná vlastníkem / jinou stranou',
      labels: ['component'],
    },
    {
      id: 'GDPR_LIABILITY',
      icon: 'fa-file-o',
      title: 'Souhlas GDPR',
      titleMpv: 'ostatní: Souhlas GDPR',
      labels: ['component'],
    },
    {
      id: 'PARCEL_SPLIT_LIABILITY',
      icon: 'fa-file-o',
      title: 'Souhlas s dělením pozemků',
      titleMpv: 'ostatní: Souhlas s dělením pozemků',
      labels: ['component'],
    },
    {
      id: 'FELLING_LIABILITY',
      icon: 'fa-file-o',
      title: 'Souhlas s kácením',
      titleMpv: 'ostatní: Souhlas s kácením',
      labels: ['component'],
    },
    {
      id: 'RESOLUTION',
      icon: 'fa-file-o',
      title: 'Usnesení',
      titleMpv: 'ostatní: Usnesení',
      labels: ['component'],
    },
    {
      id: 'EXTRACTION_KN',
      icon: 'fa-file-o',
      title: 'Výpis z KN',
      titleMpv: 'ostatní: Výpis z KN',
      labels: ['component'],
    },
    {
      id: 'NOTIFICATION',
      icon: 'fa-file-o',
      title: 'Vyrozumění',
      titleMpv: 'ostatní: Vyrozumění',
      labels: ['component'],
    },
    {
      id: 'ENTRY_PROPOSAL_NOTIFICATION',
      icon: 'fa-file-o',
      title: 'Vyrozumnění o provedeném vkladu',
      titleMpv: 'ostatní: Vyrozumění o provedeném vkladu',
      labels: ['component'],
    },
    {
      id: 'GEOMETRIC_PLAN_EXTERNAL',
      icon: 'fa-object-ungroup',
      title: 'Geometrický plán - externí',
      titleMpv: 'Geometrický plán (z EPD)',
      labels: ['component'],
    },
    {
      id: 'OPINION_SCAN_EXTERNAL',
      icon: 'fa-book',
      title: 'Sken znaleckého posudku - externí',
      titleMpv: 'Znalecký posudek (z EPD)',
      labels: ['component'],
    },

    {
      id: 'GEOMETRIC_PLAN_DOCUMENTATION',
      icon: 'fa-object-ungroup',
      title: 'Geodetická dokumentace GP',
      titleMpv: 'Geometrický plán - dokumentace',
      labels: ['gp', 'gp-mpv'],
    },
    {
      id: 'GEOMETRIC_PLAN',
      icon: 'fa-object-ungroup',
      title: 'Geometrický plán',
      titleMpv: 'Geometrický plán (pdf)',
      labels: ['gp', 'gp-mpv'],
    },
    {
      id: 'GEOMETRIC_PLAN_VFK',
      icon: 'fa-object-ungroup',
      title: 'VFK geometrického plánu',
      titleMpv: 'Geometrický plán (vfk)',
      labels: ['gp', 'gp-mpv'],
    },
    {
      id: 'GEOMETRIC_PLAN_VFK_CONCEPT',
      icon: 'fa-object-ungroup',
      title: 'VFK geometrického plánu - koncept',
      titleMpv: 'Geometrický plán (vfk - koncept)',
      labels: ['gp', 'gp-mpv'],
    },
    {
      id: 'GEOMETRIC_PLAN_PROPOSAL',
      icon: 'fa-object-ungroup',
      title: 'Návrh geometrického plánu',
      titleMpv: 'Geometrický plán - návrh',
      labels: ['gp', 'gp-mpv'],
    },

    {
      id: 'OPINION_SCAN',
      icon: 'fa-book',
      title: 'Sken znaleckého posudku',
      titleMpv: 'Znalecký posudek (vložen do MPV)',
      labels: ['opinion', 'opinion-mpv'],
    },

    {
      id: 'SAMPLE',
      icon: 'fa-book',
      title: 'Vzor',
      titleMpv: 'Vzor',
      labels: ['sample'],
    },
    {
      id: 'REVISION_SAMPLE',
      icon: 'fa-file-o',
      title: 'Vzor s vyznačením úprav',
      titleMpv: 'Vzor s vyznačením úprav',
      labels: ['sample'],
    },
    {
      id: 'TEMPLATE',
      icon: 'fa-file-text-o',
      title: 'Šablona',
      titleMpv: 'Šablona',
      labels: ['sample'],
    },
    {
      id: 'INACTIVE_TEMPLATE',
      icon: 'fa-file-text',
      title: 'Chybná šablona',
      titleMpv: 'Chybná šablona',
      labels: ['sample'],
    },
    {
      id: 'INACTIVE_SAMPLE',
      icon: 'fa-book',
      title: 'Původní vzor',
      titleMpv: 'Původní vzor',
      labels: ['sample'],
    },
    {
      id: 'INACTIVE_REVISION_SAMPLE',
      icon: 'fa-file',
      title: 'Původní vzor s vyznačením úprav',
      titleMpv: 'Původní vzor s vyznačením úprav',
      labels: ['sample'],
    },

    {
      id: 'PODKLAD',
      icon: 'fa-file-o',
      title: 'Podklad',
      titleMpv: 'Podklad',
      labels: ['doss'],
    },
    {
      id: 'DOKUMENT_K_ROZHODNUTI',
      icon: 'fa-file-text',
      title: 'Dokument k rozhodnutí',
      titleMpv: 'Dokument k rozhodnutí',
      labels: ['doss'],
    }
  ];

  /**
   * Factory method
   */
  static createById(id: string): AttachmentTypeModel {
    return AttachmentTypeModel.types.find(type => type.id === id)
      || AttachmentTypeModel.types.find(type => type.id === 'OTHER');
  }

  static getByCategory(category: string): AttachmentTypeModel[] {
    return AttachmentTypeModel.types.filter(a => a.labels.includes(category));
  }

  static getDefaultDOSSAttachmentType(): AttachmentTypeModel {
    return AttachmentTypeModel.createById('DOKUMENT_K_ROZHODNUTI');
  }
}
